import { useEffect, useState } from 'react';

export const useAutoLinks = (shouldPopulate: boolean) => {
  const [autoLinks, setAutoLinks] = useState([]);

  useEffect(() => {
    if (!shouldPopulate) return;

    const populateAutoLinks = () => {
      const headers = document.getElementsByClassName('blog-header');
      const newLinks = [];

      for (const header of headers) {
        const name = header.getAttribute('name');
        newLinks.push({ label: name, url: `#${name}` });
      }

      setAutoLinks(newLinks);
    };

    setTimeout(populateAutoLinks, 100); // Re-try after one render
    populateAutoLinks();
  }, [shouldPopulate]);

  return autoLinks;
};
